var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup_wrap lithium_battery_pop",
      staticStyle: { width: "520px" },
    },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [_vm._v("Lithium Battery")]),
        _c("div", { staticClass: "content_box lithium_battery_box" }, [
          _vm._m(0),
          _c(
            "ul",
            { staticClass: "lithium_battery_options" },
            [
              _vm._l(_vm.batteryTypeOptions, function (option) {
                return _c("li", { key: option.typeCd }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedTypeCodes,
                        expression: "selectedTypeCodes",
                      },
                    ],
                    attrs: {
                      id: "lithiumBattery_" + option.typeCd,
                      type: "checkbox",
                    },
                    domProps: {
                      value: option.typeCd,
                      checked: Array.isArray(_vm.selectedTypeCodes)
                        ? _vm._i(_vm.selectedTypeCodes, option.typeCd) > -1
                        : _vm.selectedTypeCodes,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.selectedTypeCodes,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = option.typeCd,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.selectedTypeCodes = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.selectedTypeCodes = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.selectedTypeCodes = $$c
                          }
                        },
                        _vm.clearNoLithium,
                      ],
                    },
                  }),
                  _c(
                    "label",
                    { attrs: { for: "lithiumBattery_" + option.typeCd } },
                    [_vm._v(_vm._s(option.label))]
                  ),
                ])
              }),
              _c("li", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.noLithiumYn,
                      expression: "noLithiumYn",
                    },
                  ],
                  attrs: {
                    id: "lithiumBattery_05",
                    type: "checkbox",
                    "true-value": "Y",
                    "false-value": "N",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.noLithiumYn)
                      ? _vm._i(_vm.noLithiumYn, null) > -1
                      : _vm._q(_vm.noLithiumYn, "Y"),
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.noLithiumYn,
                          $$el = $event.target,
                          $$c = $$el.checked ? "Y" : "N"
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.noLithiumYn = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.noLithiumYn = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.noLithiumYn = $$c
                        }
                      },
                      _vm.clearBatteryTypes,
                    ],
                  },
                }),
                _c("label", { attrs: { for: "lithiumBattery_05" } }, [
                  _vm._v(_vm._s(_vm.noLithiumLabel)),
                ]),
              ]),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "mt10 text_center" }, [
          _c(
            "a",
            {
              staticClass: "button blue lg",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.confirmSelection.apply(null, arguments)
                },
              },
            },
            [_vm._v("Confirm")]
          ),
          _c(
            "a",
            {
              staticClass: "button gray lg",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("Close")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "lithium_battery_desc" }, [
      _vm._v(" Please select whether the cargo contains lithium batteries."),
      _c("br"),
      _c("strong", [_vm._v("(Multiple selections are allowed.)")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }